import styled from 'styled-components';
import { IconButton } from '@mui/material';

export const ButtonWrapper = styled(IconButton)`
  &&.MuiIconButton-root {
    position: absolute;
    right: 0;
  }
`;
